import { TabItem } from '@duik/it'
import styled from '@emotion/styled'

export const StyledTabItem = styled(TabItem)`
  height: 24px;
  min-height: 26.5px;
  background: none;
  box-shadow: none;
  border: none;
  padding: 0;
  border-bottom: 2px solid transparent;
  :hover {
    border-bottom: 2px solid #fee00080;
    background: none !important;
    font-weight: 500;
  }
  span {
    color: white !important;
    font-size: 14px;
  }
  &.active {
    color: white;
    border: none;
    box-shadow: none;
    background: none;
    border-bottom: 2px solid #fee000;
    font-weight: 500;
  }
`
export const NavBarMenuDivider = styled.div`
  background: #eaedf3;
  height: 38px;
  width: 1px;
  margin: 0 50px 0 30px;
  flex-basis: 1px;
  flex-shrink: 0;
`

export const Logo = styled.img`
  width: 95px;
  padding-left: 36px;
  padding-bottom: 6px;
`
export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: 25px;
`
